import { gql } from "@apollo/client";

/*
    With id
  query ($idTest: String) {
    documents(id: [$idTest]) {

    With pagination
  query ($id: [String], $page: Int, $limit: Int) {
    documents(id: $id, page: $page, limit: $limit) {
* */

/*
export const GET_DOCUMENTS = gql`
  query ($id: [String]) {
    documents(id: $id) {
      id
      attributes
      documentLinks {
        document {
          id
          attributes
        }
      }
      assetLinks {
        asset {
          id
        }
      }
    }
  }
`;
*/

export const GET_DOCUMENTS_FULL = gql`
query ($id: [String!]) {
  documents(id: $id) {
    id
		active
    assetLinks {
      asset {
        id
				attributes
        classifications {
          id
          attributes
        }
        dateCreated
      }
      linkAttributes
      linkName
    }
    attributeSet {id}
		attributes 
		classifications {id}
		completenesses
    dateCreated 
    dateModified 
    documentLinks {
      linkAttributes
      linkName
      document {
        id
        attributes
      }
    }
    documentType {id}
    mainAssetThumbnailUrl
    workflows {id}
    assetLinks {
      asset {
        id
      }
    }
  }
}
`;